module.exports = __webpack_public_path__ + "static/img/infill.221f04d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo_sur/infill.gif
// module id = HXji
// module chunks = 0